import React from 'react';
import { FaArrowRight } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const ArticleCard = ({ article }) => {
  const navigate = useNavigate();
  
  const navigateToArticle = (slug) => {
    navigate(`/parent/article/${slug}`);
  };
  
  return (
    <div 
      className="article-card" 
      onClick={() => navigateToArticle(article.slug)}
    >
      <div className="article-image">
        <img src={article.image} alt={article.title} />
        <div className="article-category">{article.category}</div>
      </div>
      <div className="article-content">
        <h3 className="article-title">{article.title}</h3>
        {article.date && <p className="article-date">{article.date}</p>}
        <p className="article-excerpt">{article.excerpt}</p>
        <button className="read-more">
          Read article <FaArrowRight />
        </button>
      </div>
    </div>
  );
};

export default ArticleCard; 